/* global s, s_gi */
import { Cookies } from 'react-cookie';
import { getUserInfoByPathAuthJWT } from '../../utilities/userUtil/userUtil';

/**
 * Analytics class for page load and event-based analytics.
 */
export default class Analytics {

  static sAccount = 'nytbostonglobecom,nytbgglobal';
  static codeVersion = '2.9.0';
  static pageNameBase = 'user-profile';
  static channel = 'user-profile';

  /**
   * Borrowed from http://svn.boston.com/svnroot/meter-rules-engine/ 
   *
   * Return the days that have elapsed from the meter
   * @param  {String}   fm  FM Cookie value
   * @return {integer}      Number of days since metering started
   */
  static getDaysOnMeter(fm) {
    const startDateString = fm.split(':')[0].replace(/"/g, ''); // see BGLOBE-3644 for replace reason
    const year = parseInt(startDateString.substr(0, 4), 10);
    const month = parseInt(startDateString.substr(4, 2), 10) - 1;
    const day = parseInt(startDateString.substr(6, 2), 10);
    const startDate = new Date(year, month, day);
    const today = new Date();
    const oneDay = 1000 * 60 * 60 * 24;
    const delta = today.getTime() - startDate.getTime();
    const daysOnMeter = Math.ceil(delta / oneDay);

    return daysOnMeter;
  }

  /**
   * Borrowed from http://svn.boston.com/svnroot/meter-rules-engine/
   *
   * Returns fm cookie date from cookie.
   * Sample values could be
   * "20170109:12:4.2.3644627308,4.2.3656501892,4.2.3651902924,4.2.3655106554,4.2.2404761748" OR
   * 20170109:12:4.2.3644627308,4.2.3656501892,4.2.3651902924,4.2.3655106554,4.2.2404761748
   * @param  {String}         delimiter   Delimiter to separate the date
   * @return {String|boolean}             fm cookie date in MM[delimiter]DD[delimiter]YYYY format or false if not set
   */
  static getFMCookieDateWithDelimiter(fmDate, delimiter = '') {
    const currentYear = fmDate.substring(0, 4);
    const currentMonth = fmDate.substring(4, 6);
    const currentDay = fmDate.substring(6, 8);
    return [currentMonth, currentDay, currentYear].join(delimiter);
  }

  /**
   * Track custom-link event analytics with Omniture.
   * @param  {String} eVar27 Value to set as `s.eVar27`.
   * @param  {String} eventName Name of the event to track.
   */
  static trackEvent(eventName, eVar27 = null) {
    if (eVar27) {
      s.linkTrackVars = 'eVar15,eVar27,prop17,prop18,events';
      s.linkTrackEvents = 'event15';
      s.events = 'event15';
      s.eVar27 = eVar27;
    } else {
      s.linkTrackVars = 'eVar15,prop17,prop18';
      s.linkTrackEvents = 'none';
    }

    s.tl(this, 'o', eventName);
  }
   
  /**
   * Track page-load analytics with Omniture.
   * @param  {String} pageName Name of the page to track.
   */
  static pageView(pageName) {
    const cookie = new Cookies();
    const pathAuthJWT = cookie.get('pathAuthJWT');

    /* eslint-disable */
    window.s = s_gi(this.sAccount);
    s.trackingServer = 'metrics.bostonglobe.com';
    s.trackingServerSecure = 'smetrics.bostonglobe.com';
    s.trackDownloadLinks = true;
    s.trackExternalLinks = true;
    s.trackInlineStats = true;
    s.linkLeaveQueryString = false;
    // TODO: Update to live boston domain
    s.linkInternalFilters = 'localhost,facebook.com/sharer,twitter.com/intent,mailto,bostonglobe.com';
    s.linkExternalFilters = '';

    s.linkTrackVars = 'None';
    s.linkTrackEvents = 'None';
    s.usePlugins = true;
    s.p_gpv = new Function('k', 'u', ''
      + "var s=this,v='',i=u.indexOf('?'),q;if(k&&i>-1){q=u.substring(i+1);v"
      + "=s.pt(q,'&','p_gvf',k)}return v");

    s.p_gvf = new Function('t', 'k', ''
      + "if(t){var s=this,i=t.indexOf('='),p=i<0?t:t.substring(0,i),v=i<0?'T"
      + "rue':t.substring(i+1);if(p.toLowerCase()==k.toLowerCase())return s."
      + "epa(v)}return ''");

    s.getPreviousValue = new Function('v', 'c', 'el', ''
      + "var s=this,t=new Date,i,j,r='';t.setTime(t.getTime()+1800000);if(el"
      + "){if(s.events){i=s.split(el,',');j=s.split(s.events,',');for(x in i"
      + '){for(y in j){if(i[x]==j[y]){if(s.c_r(c)) r=s.c_r(c);v?s.c_w(c,v,t)'
      + ":s.c_w(c,'no value',t);return r}}}}}else{if(s.c_r(c)) r=s.c_r(c);v?"
      + "s.c_w(c,v,t):s.c_w(c,'no value',t);return r}");

    const s_doPlugins = function () {
      // 's_pv' and 's_p6' are cookie names
      // marketing.adobe.com/resources/help/en_US/sc/implement/getPreviousValue.html
      s.prop37 = s.getPreviousValue(s.pageName, 's_pv');
      s.prop73 = s.getPreviousValue(s.prop6, 's_p6');
    };
    s.doPlugins = s_doPlugins;

    // Clear variables
    s.clearVars();
    /* eslint-enable */

    const p1 = s.Util.getQueryParam('p1', window.location.href);
    const sCampaign = s.Util.getQueryParam('s_campaign', window.location.href);

    s.pageName = `${this.pageNameBase} | ${pageName}`;
    s.channel = this.channel;
    s.campaign = sCampaign;

    /**
     * s.props
     */

    // Subsection
    s.prop1 = `${this.pageNameBase} | BGC Registration`;

    // Page/Asset Type
    s.prop6 = 'ugc profile page';

    // p1 Value
    s.prop7 = p1;

    // CMS
    s.prop17 = 'Pages';

    // Environment
    const environment = {
      localhost: 'Dev',
      sandbox: 'QA',
      prod: 'Live',
    };
    s.prop18 = environment[process.env.REACT_APP_ENVIRONMENT];

    // s_campaign Value
    s.prop26 = sCampaign;

    // Login Status
    s.prop35 = 'logged out';

    // Publication Name
    s.prop41 = 'BostonGlobe.com';

    // Login Type
    s.prop42 = 'Metered';

    // Page URL
    s.prop43 = 'D=g';

    // Code Version
    s.prop63 = this.codeVersion;

    /**
     * s.events
     */

    // event2
    if (s.events) {
      if (s.events.indexOf('event2') === -1) {
         s.events = `${s.events},event2`
      }
    } else {
      s.events = 'event2';
    }

    /**
     * s.eVars
     */

    // p1 Value
    s.eVar1 = p1;

    // Cookie values used for the following eVars
    const FM = cookie.get('FM');
    const FMa = cookie.get('FMa');
    const currentFMDate = (FM) ? FM.split(':')[0] : false;

    if (FM) {
      // Days on Meter
      s.eVar4 = this.getDaysOnMeter(FM);
    }

    if (FMa) {
      // Days Since First Visit
      s.eVar5 = this.getDaysOnMeter(FMa);

      // Original Meter Cookie Date
      s.eVar6 = this.getFMCookieDateWithDelimiter(FMa, '/');
    }

    if (currentFMDate) {
      // Current Meter Cookie Date
      s.eVar7 = this.getFMCookieDateWithDelimiter(currentFMDate, '/');
    }

    // Page Name
    s.eVar15 = 'D=pageName';

    // Login Status
    s.eVar20 = s.prop35;

    // Publication Name
    s.eVar41 = 'BostonGlobe.com';

    // Login Type
    s.eVar42 = s.prop42;

    // BCSessionID
    s.eVar68 = cookie.get('BCSessionID');

    // Make request to Regi service to get user data.
    if (pathAuthJWT) {
      getUserInfoByPathAuthJWT(pathAuthJWT).then((response) => {
        const loginStatus = response.authenticated || false;

        console.log('response', response);

        // Login Type
        // Borrowed from the Opt-in Page
        let loginType = 'Metered';
        let subscriptionData;
        if (response.subscriptionList && response.subscriptionList.subscription) {
          // Arbirarily select the first subscription if an array
          if (Array.isArray(response.subscriptionList.subscription)) {
            if (response.subscriptionList.subscription.length > 0) {
              subscriptionData = response.subscriptionList.subscription[0];
            }
          } else {
            subscriptionData = response.subscriptionList.subscription;
          }

          console.log('subscriptionData', subscriptionData);

          if (subscriptionData) {
            if (subscriptionData.productId === 'eGlobe' && subscriptionData.subscriptionTypeKey === 100) {
              loginType = 'Free Trial';
            } else if ( subscriptionData.productId === 'eGlobe' ) {
              loginType = 'Digital';
            } else {
              loginType = 'Home Delivery';
            }
          }
        }

        // Login Status
        s.prop35 = loginStatus ? 'logged in' : 'logged out';

        // Login Type
        s.prop42 = loginType || s.prop42;

        // Login Status
        s.eVar20 = s.prop35;

        // Login Type
        s.eVar42 = s.prop42;

        // Fire page load analytics.
        s.t();
      });
    } else {
      // Fire page load analytics.
      s.t();
    }
  }
}



// WEBPACK FOOTER //
// ./src/utilities/Analytics/Analytics.js